export const DUMMYUPLOADPHOTOSMAINBOX = {
  display: "flex",
  justifyContent: "space-between",
  ml: { sm: 3 },
  mb: { sm: 8, xs: 2 },
  flexWrap: "wrap",
}
export const CANCELICON = { color: "red" }